export const hasAdditional = event => Boolean(event?.is_additional_measuring || event?.additional_measurement?.status === 'active');
export const additionalId = event => event?.additional_measurement?.status === 'active' ? event.additional_measurement.id : null;
export const additionalStopPayload = (cycle, reason) => ({
  confirm_additional_stop: true,
  expected_additional_id: cycle?.status === 'active' ? cycle.id : null,
  additional_stop_reason: reason,
});